(() => {
  'use strict';
  class AmoreStickyBuy extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.button = this.querySelector('button');
      this.price = this.querySelector('[data-amore-sticky-price]');
      this.error = this.querySelector('[data-amore-sticky-error]');
      if (!this.productInfo || !this.button) return;
      this.guardSubmit = event => {
        this.sync();
        if (!this.primary || this.primary.disabled || this.primary.getAttribute('aria-disabled') === 'true' || this.primary.classList.contains('loading')) event.preventDefault();
      };
      this.button.addEventListener('click', this.guardSubmit);
      this.media = window.matchMedia('(max-width: 749px)');
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
      };
      this.position = () => {
        if (!this.primary) { this.hidden = true; return; }
        const show = this.media.matches && this.primary.getBoundingClientRect().bottom < 0;
        this.hidden = !show;
        if (show) document.documentElement.style.setProperty('--amore-sticky-buy-height', `${this.getBoundingClientRect().height}px`);
      };
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.schedule();
      });
      this.observer.observe(this.productInfo, {
        subtree: true, childList: true, characterData: true, attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'aria-haspopup', 'class', 'value', 'checked', 'hidden']
      });
      window.addEventListener('scroll', this.position, { passive: true });
      window.addEventListener('resize', this.position, { passive: true });
      this.media.addEventListener('change', this.position);
      document.body.classList.add('amore-has-sticky-buy');
      this.sync();
    }
    sync() {
      const form = document.getElementById(this.dataset.form);
      this.primary = form?.querySelector('button[name="add"]');
      if (!this.primary) { this.hidden = true; return; }
      const disabled = this.primary.disabled || this.primary.getAttribute('aria-disabled') === 'true' || this.primary.classList.contains('loading');
      this.button.disabled = disabled;
      this.button.setAttribute('aria-disabled', String(disabled));
      const popup = this.primary.getAttribute('aria-haspopup');
      if (popup) this.button.setAttribute('aria-haspopup', popup);
      else this.button.removeAttribute('aria-haspopup');
      this.button.textContent = this.primary.classList.contains('loading')
        ? this.dataset.loadingLabel
        : (this.primary.querySelector('span')?.textContent.trim() || this.primary.textContent.trim());

      const nativePrice = document.getElementById(this.dataset.price);
      const priceMarkup = nativePrice?.innerHTML || '';
      if (priceMarkup !== this.lastPriceMarkup && this.price) {
        this.price.replaceChildren();
        if (nativePrice) {
          const copy = nativePrice.cloneNode(true);
          copy.removeAttribute('id');
          copy.removeAttribute('role');
          copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          this.price.append(copy);
        }
        this.lastPriceMarkup = priceMarkup;
      }
      if (this.price) this.price.hidden = !nativePrice || nativePrice.classList.contains('hidden');
      const nativeError = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
      const errorText = nativeError && !nativeError.hidden
        ? nativeError.querySelector('.product-form__error-message')?.textContent.trim() || ''
        : '';
      if (this.error) {
        this.error.textContent = errorText;
        this.error.hidden = !errorText;
      }
      this.position();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.guardSubmit);
      if (this.frame) cancelAnimationFrame(this.frame);
      window.removeEventListener('scroll', this.position);
      window.removeEventListener('resize', this.position);
      this.media?.removeEventListener('change', this.position);
      if (!document.querySelector('amore-sticky-buy')) {
        document.body.classList.remove('amore-has-sticky-buy');
        document.documentElement.style.removeProperty('--amore-sticky-buy-height');
      }
    }
  }

  if (!customElements.get('amore-sticky-buy')) customElements.define('amore-sticky-buy', AmoreStickyBuy);
})();
